function initAcc(elem) {
    const acc = document.querySelectorAll(elem);

    acc.forEach(jsAcc => {
        const accButton = jsAcc.querySelector('.a-btn');

        accButton.addEventListener('click', (e) => {
            const accContainer = jsAcc.querySelector('.a-container');
            accContainer.classList.toggle('active');
        })
    })
}
const accContList = ['.js-accordion', '.js-inner-accordion'];
accContList.forEach(item => {
    initAcc(item);
})

function initAcc_new(elem) {
    const acc = document.querySelectorAll(elem);

    acc.forEach(jsAcc => {
        const accButton = jsAcc.querySelector('.btn-collapse');

        accButton.addEventListener('click', (e) => {
            const accContainer = jsAcc.querySelector('.col-collapse');
            accContainer.classList.toggle('active');
        })
    })
}
const accContList_new = ['.row-collapse'];
accContList_new.forEach(item => {
    initAcc_new(item);
})